<template>
    <div id="secure">
        <h1>Secure Area</h1>
        <p>
            This is a secure area
            <button type="button" v-on:click="kelas()" class="button">Go to kelas</button>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'Secure',
        data () {
            return {};
        },
        beforeMount(){
            this.$emit("authenticated", true)
            console.log('before mount hoho')
        },
        methods: {
            kelas (){
                this.$router.push('kelas')
            }

        }
    }
</script>

<style scoped>
    #secure {
        background-color: #FFFFFF;
        border: 1px solid #CCCCCC;
        padding: 20px;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Secure.vue